module.exports = __webpack_public_path__ + "img/i_c_new_09.37c3f4e2.svg";